import React from "react";

// components
import SectionContainer from "core/SectionContainer";
import Heading from "core/Heading";
import Collections from "core/Collections";
import LoadingSpinner from "core/LoadingSpinner";

// helpers
import useLoadMore from "frontend/hooks/useLoadMore";
import { getArrayOfCollectionIcons } from "icons/helpers";

// queries:
import { GET_ICON_COLLECTIONS } from "./queries";

const CollectionSearch = ({ match }) => {
    const { q } = match.params;
    const { items, loading, loadMore, totalCount } = useLoadMore({
        query: GET_ICON_COLLECTIONS,
        queryVariables: { query: q },
        pathToListKey: "collectionSearch.items",
        pathToTotalCountKey: "collectionSearch.totalCount",
        limit: 6
    });

    if (loading) return <LoadingSpinner />;

    // helper to reformat data to match Collections component:
    const collections = items.map(collection => {
        return {
            title: collection.name,
            url: `/${collection.creator.username}/collection/${collection.slug}/`,
            imageSrc: getArrayOfCollectionIcons({
                icons: collection.icons
            }),
            type: "secondary",
            usePlaceholder: true,
            subtitle: collection.icons.totalCount + " icons"
        };
    });

    return (
        <SectionContainer topSpacing="2xl" bottomSpacing="3xl">
            <Heading type="h2" size="xs" bottomSpacing="xl">
                Results for "{q}"
            </Heading>
            <Collections collections={collections} />
        </SectionContainer>
    );
};

export default CollectionSearch;
